import api from '@/api'

export default {
    getProcessList: (): Promise<Array<task.webpartProcessResponse>> => {
        return api.get<Array<task.webpartProcessResponse>>({
            url: '/task/process/api/webpart/userprocess'
        });
    }
}